import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import { PERFIL_ADMIN, getAdminEmpresa, getFinanceiroEmpresa } from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import DatePicker from 'react-datepicker/es';
import { renderFieldSelect, requiredSelect } from '../../util/inputs';
import buscarDadosVexadoBI from '../../actions/vexado-bi/buscarDadosVexadoBI';
import limparDadosVexadoBI from '../../actions/vexado-bi/limparDadosVexadoBI';
import { formatarReal } from '../../util/numberUtil';
import GraficoVendasPorDiaMesAno from './GraficoVendasPorDiaMesAno';
import GraficoTopBilheteiros from './GraficoTopBilheteiros';
import GraficoPorRotas from './GraficoPorRotas';
import GraficoPorEmpresaAgencia from './GraficoPorEmpresaAgencia';
import { TIPO_RELATORIO, GRUPOS, ITEM_TODAS_EMPRESAS, tipoRelatorio } from '../../util/constantsUtil';
import Select from 'react-select';
import buscarEmpresas from '../../actions/empresa/buscarEmpresas';
import GraficoTodasEmpresas from './GraficoTodasEmpresas';
import GraficoPorTrechos from './GraficoPorTrecho';
import GraficoPorVeiculo from './GraficoPorVeiculo';

export class PainelVexadoBI extends React.Component {

    constructor(props) {
        super(props);
        this.expandir = this.expandir.bind(this);
        this.state = {
            tipoRelatorio: null,
            empresasSelecionadas: [],
            gruposSelecionados: [],            
            dataInicio: new Date().setMonth(new Date().getMonth() - 1),
            dataFim: new Date(),            
            graficoSelecionado: ''
        };

    }

    retornaTodasEmpresas() {
        const empresasMapeadas = this.props.empresas.map(elemento => ({
            label: elemento.nomeFantasia,
            value: elemento.id
        }));

        return [...empresasMapeadas, ITEM_TODAS_EMPRESAS];
    }

    exibirComboEmpresas() {
        return (
            <div>
                <Select
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    value={this.state.empresasSelecionadas}
                    isMulti
                    placeholder='Selecione...'
                    styles={{
                        control: base => ({
                            ...base,
                            minHeight: 32,
                            fontSize: 16,
                            width: '100%',
                            borderColor: '#e4e7ea',
                            cursor: 'pointer'
                        })
                    }}
                    options={this.retornaTodasEmpresas()}
                    onChange={event => this.setState({ empresasSelecionadas: [...event] })}
                />
            </div>
        )
    }

    exibirComboGrupos() {
        return (
            <React.Fragment>
                <Select
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    value={this.state.gruposSelecionados}
                    isMulti
                    placeholder='Selecione...'
                    styles={{
                        control: base => ({
                            ...base,
                            minHeight: 32,
                            fontSize: 16,
                            width: '100%',
                            borderColor: '#e4e7ea',
                            cursor: 'pointer'
                        })
                    }}
                    options={GRUPOS}
                    onChange={event => this.setState({ gruposSelecionados: [...event] })}
                />
            </React.Fragment>
        )
    }

    componentDidMount() {
        if (this.naoEhPerfilAdmin()) {
            this.setState({ tipoRelatorio: tipoRelatorio.empresa });
            this.setState({ empresasSelecionadas: [{ label: this.props.empresaSelecionada.nomeFantasia, value: this.props.empresaSelecionada.id }, ...this.state.empresasSelecionadas] });
            this.props.buscarEmpresas(this.props.empresaSelecionada.id);
        } else {
            this.props.buscarEmpresas();
        }

        this.props.limparDadosVexadoBI();        
        this.props.buscarDadosVexadoBI(this.props.empresaSelecionada.id, this.state.dataInicio, this.state.dataFim, null, null, this.state.empresasSelecionadas.length <= 1, false);
    }

    naoEhPerfilAdmin() {
        return !this.ehPerfilAdmin();
    }

    ehPerfilAdmin() {
        return validaPerfis([PERFIL_ADMIN])
    }

    getGruposSelectedValues = (selectedItems, allLabel, defaultValues) => {
        if (selectedItems.map(it => it.value).filter(it => it === allLabel).length > 0) {
            return defaultValues.filter(it => !['TODOS', 'SEM_GRUPO'].includes(it.value)).map(it => it.value)
                    .join(',');
        }
        if (selectedItems.map(it => it.value).filter(it => it === 'SEM_GRUPO').length > 0) {
            return selectedItems.filter(it => !['SEM_GRUPO'].includes(it.value))
                    .map(it => it.value).join(',')
        }
        return selectedItems.map(it => it.value).join(',');
    }

    getEmpresasSelectedValues = (selectedItems, allLabel, defaultValues) => {        
        if (selectedItems.map(it => it.label).filter(it => it === allLabel).length > 0) {
            return defaultValues.map(it => it.id).join(',');
        }
        return selectedItems.map(it => it.value).join(',');
    }
    
    getGruposOuEmpresas = () => {
        const { gruposSelecionados, empresasSelecionadas } = this.state;

        let grupos = null;
        let empresas = null;
        let empresasSemGrupo = false;
            
        if (this.state.tipoRelatorio === tipoRelatorio.grupo) {
            grupos = this.getGruposSelectedValues(gruposSelecionados, 'TODOS', GRUPOS);
            empresasSemGrupo = gruposSelecionados.map(it => it.value).filter(it => it === 'SEM_GRUPO').length > 0;
        }
    
        if (this.state.tipoRelatorio === tipoRelatorio.empresa) {            
            empresas = this.getEmpresasSelectedValues(empresasSelecionadas, 'TODAS', this.props.empresas);
        }
    
        return { grupos, empresas, empresasSemGrupo };
    }

    buscar() {                
        const { grupos, empresas,  empresasSemGrupo } = this.getGruposOuEmpresas();        
        this.props.buscarDadosVexadoBI(this.props.empresaSelecionada.id, this.state.dataInicio, this.state.dataFim, empresas, grupos, this.state.empresasSelecionadas.length <= 1, empresasSemGrupo);
    }

    exibirCardValor(titulo, valor) {
        return <div className="card" style={{ borderRadius: '10px' }}>
            <div className="card-body btn-laranja" style={{ borderRadius: '10px' }}>
                <h5 className="card-title">{titulo}</h5>
                <p className="card-text">{valor}</p>
            </div>
        </div>
    }

    exibirGraficoExpandido() {
        return <div className="row-full">
            <div className="row mt-5">
                <div className="col-md-12">
                    <div className="text-right">
                        <button className='btn bg-white ' onClick={() => this.setState({ graficoSelecionado: '' })}>
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
            {this.exibirGraficoDadoTipoSelecionado()}
        </div>
    }

    exibirGraficoDadoTipoSelecionado() {
        switch (this.state.graficoSelecionado) {
            case 'rota':
                return <GraficoPorRotas full={true} />
            case 'empresaAgencia':
                return <GraficoPorEmpresaAgencia agenciaHabilitado={this.state.empresasSelecionadas.length <= 1}
                    full={true} />
            case 'diaMes':
                return <GraficoVendasPorDiaMesAno full={true} />;
            case 'vendedor':
                return <GraficoTopBilheteiros full={true} />;
            case 'empresas':
                return <GraficoTodasEmpresas full={true} />;
            case 'trecho':
                return <GraficoPorTrechos full={true} />;
            case 'veiculo':
                    return <GraficoPorVeiculo full={true} />;    
            default:
                return ''
        }
    }

    expandir(tipo) {
        this.setState({ graficoSelecionado: tipo })
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;        
        return (this.state.graficoSelecionado ? this.exibirGraficoExpandido() :

            <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="row-full mb-5">
                    <Titulo texto="VexBI" urlRetorno="/" />
                    <form onSubmit={handleSubmit(this.buscar.bind(this))}>
                        <fieldset className='border col-12 justify-content-center'
                            style={{ backgroundColor: '#FFF' }}>
                            <div className='row mt-5 mb-5'>
                                <div className='col-md-2 col-12 col-sm-12'>
                                    <span className="label-data">De</span>
                                    <DatePicker
                                        value={this.state.dataInicio}
                                        className='form-control form-control-lg campo-busca data-itinerario'
                                        locale="pt-BR"
                                        onChange={date => {
                                            this.setState({ dataInicio: date });
                                        }
                                        }
                                        selected={this.state.dataInicio}
                                        dateFormat="dd/MM/yyyy" />
                                </div>
                                <div className='col-md-2 col-12 col-sm-12'>
                                    <span className="label-data ">Até</span>
                                    <DatePicker
                                        className='form-control form-control-lg campo-busca data-itinerario'
                                        locale="pt-BR"
                                        value={this.state.dataFim}
                                        selected={this.state.dataFim}
                                        onChange={date => {
                                            this.setState({ dataFim: date });
                                        }
                                        }
                                        dateFormat="dd/MM/yyyy" />
                                </div>
                                {this.ehPerfilAdmin() &&
                                    <div className='col-md-2 col-12 col-sm-12'>
                                        <span className="label-dat">Tipo de relatório</span>
                                        <div className='mt-1'>
                                            <Field name='tipoRelatorio'
                                                options={TIPO_RELATORIO}
                                                onChange={event => this.setState({ tipoRelatorio: event.value })}
                                                component={renderFieldSelect}
                                                placeholder='Selecione...' validate={requiredSelect} />
                                        </div>
                                    </div>}

                                {this.state.tipoRelatorio === tipoRelatorio.grupo ? <div className='col-md-3 col-12 col-sm-12'>
                                    <span className="label-dat">Grupo</span>
                                    <div className='mt-1'>
                                        <Field id='grupo' name='grupo'
                                            component={this.exibirComboGrupos.bind(this)} />
                                    </div>
                                </div> : ''}
                                {this.state.tipoRelatorio === tipoRelatorio.empresa ? <div className='col-md-3 col-12 col-sm-12'>
                                    <span className="label-dat">Empresa</span>
                                    <div className='mt-1'>
                                        <Field id='empresa' name='empresa'
                                            component={this.exibirComboEmpresas.bind(this)} />
                                    </div>
                                </div> : ''}                                
                                <div className='col-md-3 col-12 col-sm-12'>
                                    <span className="label-data"> </span>
                                    <button
                                        disabled={invalid || submitting || 
                                            !this.state.dataInicio || !this.state.dataFim
                                            || (this.state.tipoRelatorio === 'GRUPO' && !this.state.gruposSelecionados.length)
                                            || (this.state.tipoRelatorio === 'EMPRESA' && !this.state.empresasSelecionadas.length)}
                                        type="submit" className="btn btn-laranja">
                                        Buscar
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                    <div className="card-deck mt-5 texto-centralizado">
                        {this.exibirCardValor('Faturamento Total', formatarReal(this.props.vexadoBI.valorTotalFaturamento.toString()))}
                        {this.exibirCardValor('Cancelamento Total', formatarReal(this.props.vexadoBI.valorTotalCancelamento.toString()))}
                        {this.exibirCardValor('Líquido Total', formatarReal(this.props.vexadoBI.valorTotalLiquido.toString()))}
                        {this.exibirCardValor('Imposto Líquido', formatarReal(this.props.vexadoBI.valorTotalImposto.toString()))}
                        {this.exibirCardValor('Ticket Médio', formatarReal(this.props.vexadoBI.valorTotalTicketMedio.toString()))}
                    </div>
                    <div className="mt-5 row">
                        <div className="col-md-6">
                            <GraficoPorRotas expandir={this.expandir} />
                        </div>
                        <div className="col-md-6">
                            <GraficoPorEmpresaAgencia expandir={this.expandir}
                                agenciaHabilitado={this.state.empresasSelecionadas.length <= 1}
                                />
                        </div>
                    </div>
                    <div className="mt-5 row">
                        <div className="col-md-6">
                            <GraficoVendasPorDiaMesAno expandir={this.expandir} />
                        </div>
                        <div className="col-md-6">
                            <GraficoTopBilheteiros expandir={this.expandir}
                                dataInicio={this.state.dataInicio}
                                dataFim={this.state.dataFim}
                                getGruposOuEmpresas={this.getGruposOuEmpresas}                                
                                empresaSelecionadaId={this.props.empresaSelecionada.id}                                
                                />
                        </div>
                    </div>
                    <div className="mt-5 row">
                        <div className="col-md-6">
                            <GraficoTodasEmpresas expandir={this.expandir} />
                        </div>
                        <div className="col-md-6">
                            <GraficoPorTrechos expandir={this.expandir} />
                        </div>
                    </div>
                    <div className="mt-5 row">
                        <div className="col-md-6">
                            <GraficoPorVeiculo expandir={this.expandir} />
                        </div>
                    </div>
                </div>
            </Autorizacao>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresas: state.empresas,
        empresaSelecionada: state.empresaSelecionada,
        vexadoBI: state.vexadoBI 
    }
}

export default connect(mapStateToProps, {
    buscarDadosVexadoBI,
    limparDadosVexadoBI,
    buscarEmpresas
})(reduxForm({
    form: 'formularioVexadoBI',
})(PainelVexadoBI))
